import type { TFunction } from 'i18next';

import { PAYMENT_METHOD_TYPE } from './paymentMethodType.ts';

export const getPaymentMethodTypeI18n = (key: string, t: TFunction): string => {
  const keys = {
    [PAYMENT_METHOD_TYPE.PIX]: t('Pix'),
    [PAYMENT_METHOD_TYPE.PIX_COB]: t('Pix'),
    [PAYMENT_METHOD_TYPE.PIX_COBV]: t('Pix'),
    [PAYMENT_METHOD_TYPE.PIX_CREDIARY]: t('Pix Crediary'),
    [PAYMENT_METHOD_TYPE.CREDIT_CARD]: t('Credit Card'),
    [PAYMENT_METHOD_TYPE.BOLETO]: t('Boleto'),
    [PAYMENT_METHOD_TYPE.ITP]: t('ITP'),
  };

  return keys[key];
};
